import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pplus-admin-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss']
})
export class PermissionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
